
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyCheckbox as SkyCheckboxElement, SkyCheckboxValidationErrorDetail, SkyCheckboxValueChangedDetail, SkyCheckboxValueClearedDetail } from '@sky.ui/core/sky-checkbox';
 
 

 
 export const SkyCheckbox = createComponent({
   displayName: 'SkyCheckbox',
   react: React,
   tagName: 'sky-checkbox',
   elementClass: SkyCheckboxElement,
   events: {
     
     onValueChanged: 'value-changed' as EventName<CustomEvent<SkyCheckboxValueChangedDetail>>,
     onValidationError: 'validation-error' as EventName<CustomEvent<SkyCheckboxValidationErrorDetail>>,
     onValueCleared: 'value-cleared' as EventName<CustomEvent<SkyCheckboxValueClearedDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-checkbox';
